module.exports = __webpack_public_path__ + "media/assets/img/products/studio_international-selected-dbf5cd77399215ace2f97b506b646916.svg";